// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"68":"76a58f2a","666":"5e504d7d"}[chunkId] + ".css";
};